// Tablet-side connectivity diary: queued locally (survives reloads) and sent with each heartbeat.
const BOOT_AT = new Date().toISOString();
const MAX = 300;
let jsErrors = 0;

const key = (code) => `gb_diag_q_${code}`;
const read = (code) => { try { return JSON.parse(localStorage.getItem(key(code)) || "[]"); } catch { return []; } };
const write = (code, q) => { try { localStorage.setItem(key(code), JSON.stringify(q.slice(-MAX))); } catch { /* storage full */ } };

export const logDiag = (code, e, d) => {
  if (!code) return;
  const q = read(code);
  q.push({ e, t: new Date().toISOString(), ...(d ? { d: String(d).slice(0, 200) } : {}) });
  write(code, q);
};

export const startDiag = (code) => {
  logDiag(code, "boot");
  const onOff = () => logDiag(code, "net_off");
  const onOn = () => logDiag(code, "net_on");
  const onVis = () => logDiag(code, document.visibilityState === "hidden" ? "hidden" : "visible");
  const onErr = (ev) => { jsErrors += 1; if (jsErrors <= 5) logDiag(code, "js_error", ev?.message || ev?.reason?.message || "error"); };
  window.addEventListener("offline", onOff);
  window.addEventListener("online", onOn);
  document.addEventListener("visibilitychange", onVis);
  window.addEventListener("error", onErr);
  window.addEventListener("unhandledrejection", onErr);
  return () => {
    window.removeEventListener("offline", onOff);
    window.removeEventListener("online", onOn);
    document.removeEventListener("visibilitychange", onVis);
    window.removeEventListener("error", onErr);
    window.removeEventListener("unhandledrejection", onErr);
  };
};

export const diagPayload = (code) => {
  const events = read(code);
  const c = navigator.connection || {};
  return {
    sent: events.length,
    body: {
      diag: {
        now: new Date().toISOString(), boot_at: BOOT_AT, online: navigator.onLine,
        visibility: document.visibilityState, connection: c.type || c.effectiveType || null,
        js_errors: jsErrors, app_version: process.env.REACT_APP_VERSION || null, events,
      },
    },
  };
};

export const ackDiag = (code, n) => write(code, read(code).slice(n));

export const failDiag = (code, err) => logDiag(code, err?.response ? "hb_fail_srv" : "hb_fail_net", err?.response?.status || err?.message);
